import script from "./HomeComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HomeComponent.vue?vue&type=style&index=0&id=e2f3d318&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2f3d318"]])

export default __exports__